import { n as e, t } from "./utils-DiFe-_ei.js";
import { i as n, o as r, r as i, s as a, t as o } from "./dist-BWsUe_id.js";
import { Button as s } from "./foundations/button.js";
import "./button-C8zrAH2m.js";
import { t as c } from "./createLucideIcon-CJLgHpqc.js";
import { t as l } from "./chevron-left-ObWP-3BV.js";
import { t as u } from "./chevron-right-C4-3WHKK.js";
import { t as d } from "./search-Chd7o8f1.js";
import { DialogOverlay as f } from "./foundations/dialog.js";
import "./dialog-DGSJCBAd.js";
import { a as p, h as m, i as h, o as g, r as _, t as v } from "./dropdown-menu-BLAt-Aef.js";
import "./dropdown-menu-DPef8Amn.js";
import { Sheet as y, SheetContent as b, SheetHeader as x, SheetTitle as S } from "./foundations/sheet.js";
import "./sheet-CvqhDCEw.js";
import { Skeleton as C } from "./foundations/skeleton.js";
import "./skeleton-bhKtal4a.js";
import { Typography as w } from "./foundations/typography.js";
import "./typography-CTPDhvds.js";
import { useIsMobile as T } from "./lib/useIsMobile.js";
import { i as E, n as D, r as O, t as ee } from "./tooltip-BBk91-lt.js";
import "./tooltip-CVlMtE-y.js";
import "./Pagination-Dh2R94_t.js";
import { Fragment as k, useCallback as A, useEffect as j, useId as M, useRef as N, useState as P } from "react";
import { Fragment as F, jsx as I, jsxs as L } from "react/jsx-runtime";
var R = c("chevrons-up-down", [["path", {
	d: "m7 15 5 5 5-5",
	key: "1hf1tw"
}], ["path", {
	d: "m7 9 5-5 5 5",
	key: "sgt6xg"
}]]), z = c("menu", [
	["path", {
		d: "M4 5h16",
		key: "1tepv9"
	}],
	["path", {
		d: "M4 12h16",
		key: "1lakjw"
	}],
	["path", {
		d: "M4 19h16",
		key: "1djgab"
	}]
]), B = c("panel-left", [["rect", {
	width: "18",
	height: "18",
	x: "3",
	y: "3",
	rx: "2",
	key: "afitv7"
}], ["path", {
	d: "M9 3v18",
	key: "fh3hqa"
}]]), V = c("panel-right-close", [
	["rect", {
		width: "18",
		height: "18",
		x: "3",
		y: "3",
		rx: "2",
		key: "afitv7"
	}],
	["path", {
		d: "M15 3v18",
		key: "14nvp0"
	}],
	["path", {
		d: "m8 9 3 3-3 3",
		key: "12hl5m"
	}]
]), te = c("panel-right", [["rect", {
	width: "18",
	height: "18",
	x: "3",
	y: "3",
	rx: "2",
	key: "afitv7"
}], ["path", {
	d: "M15 3v18",
	key: "14nvp0"
}]]), H = c("panel-right-open", [
	["rect", {
		width: "18",
		height: "18",
		x: "3",
		y: "3",
		rx: "2",
		key: "afitv7"
	}],
	["path", {
		d: "M15 3v18",
		key: "14nvp0"
	}],
	["path", {
		d: "m10 15-3-3 3-3",
		key: "1pgupc"
	}]
]);
//#endregion
//#region src/components/navigation/PaginationFooter/PaginationFooter.tsx
function U({ page: e, totalPages: n, hasNextPage: r, hasMore: i = !1, isFetching: a = !1, onPreviousPage: o, onNextPage: c, className: d }) {
	return /* @__PURE__ */ L("nav", {
		"aria-label": "Pagination",
		className: t("bg-muted/30 text-muted-foreground flex items-center justify-between rounded-b-lg border-x border-b px-4 py-3 text-[12.5px]", d),
		children: [/* @__PURE__ */ L("span", { children: [
			"Page ",
			e,
			" of ",
			n,
			i ? "+" : ""
		] }), /* @__PURE__ */ L("div", {
			className: "flex gap-1",
			children: [/* @__PURE__ */ L(s, {
				variant: "ghost",
				size: "sm",
				disabled: e <= 1,
				onClick: o,
				className: "h-7 text-xs",
				children: [/* @__PURE__ */ I(l, { className: "mr-1 size-3.5" }), "Prev"]
			}), /* @__PURE__ */ L(s, {
				variant: "ghost",
				size: "sm",
				disabled: !r || a,
				onClick: c,
				className: "h-7 text-xs",
				children: ["Next", /* @__PURE__ */ I(u, { className: "ml-1 size-3.5" })]
			})]
		})]
	});
}
//#endregion
//#region src/components/navigation/TabBar/TabBar.tsx
function W({ tabs: e, activeKey: n, onChange: r, isLoading: i = !1 }) {
	return /* @__PURE__ */ I("div", {
		className: "border-b",
		children: /* @__PURE__ */ I("div", {
			className: "flex overflow-x-auto",
			children: e.map(({ key: e, label: a, count: o }) => /* @__PURE__ */ L("button", {
				type: "button",
				onClick: () => r(e),
				className: t("inline-flex shrink-0 items-center gap-2 whitespace-nowrap border-b-2 px-3 py-2.5 text-sm transition-colors", e === n ? "border-foreground font-medium text-foreground" : "border-transparent text-muted-foreground hover:cursor-pointer hover:text-foreground"),
				children: [a, i ? /* @__PURE__ */ I(C, {
					variant: "text",
					className: "h-3 w-4"
				}) : o !== void 0 && /* @__PURE__ */ I("span", {
					"aria-hidden": "true",
					className: "text-muted-foreground text-[11.5px] font-medium tabular-nums",
					children: o
				})]
			}, e))
		})
	});
}
//#endregion
//#region src/components/navigation/BottomNav/BottomNav.tsx
function G(e, t) {
	return t === e || t.startsWith(`${e}/`);
}
function K({ items: n, fab: r, currentPath: i, onSelect: a, linkComponent: o = "a" }) {
	let [c, l] = P(!1), u = Math.ceil(n.length / 2), d = n.slice(0, u), f = n.slice(u);
	function p(n) {
		let r = G(n.to, i);
		return /* @__PURE__ */ L(o, {
			...e(o, n.to),
			className: t("flex flex-col items-center justify-center gap-0.5 py-2 text-xs transition-colors", r ? "text-primary font-medium" : "text-muted-foreground"),
			children: [/* @__PURE__ */ I("span", {
				className: "[&>svg]:size-5",
				children: n.icon
			}), n.label]
		}, n.to);
	}
	function m(e) {
		l(!1), a(e);
	}
	return /* @__PURE__ */ L(F, { children: [/* @__PURE__ */ I("nav", {
		"aria-label": "Bottom navigation",
		className: "bg-background fixed inset-x-0 bottom-0 z-40 border-t pb-[env(safe-area-inset-bottom)] md:hidden",
		children: /* @__PURE__ */ L("div", {
			className: "grid items-center",
			style: { gridTemplateColumns: `repeat(${n.length + 1}, minmax(0, 1fr))` },
			children: [
				d.map(p),
				/* @__PURE__ */ I("div", {
					className: "flex items-center justify-center",
					children: /* @__PURE__ */ I(s, {
						type: "button",
						size: "icon",
						"aria-label": r.label,
						onClick: () => l(!0),
						className: "-mt-6 size-14 shadow-lg",
						children: r.icon
					})
				}),
				f.map(p)
			]
		})
	}), /* @__PURE__ */ I(y, {
		open: c,
		onOpenChange: l,
		children: /* @__PURE__ */ L(b, {
			side: "bottom",
			className: "px-4 pb-8",
			children: [/* @__PURE__ */ I(x, { children: /* @__PURE__ */ I(S, { children: r.label }) }), /* @__PURE__ */ I("div", {
				className: "mt-4 flex flex-col gap-1",
				children: r.options.map((e) => /* @__PURE__ */ L("button", {
					type: "button",
					onClick: () => m(e.to),
					className: "hover:bg-muted flex items-center gap-3 rounded-lg px-3 py-3 text-left text-sm transition-colors",
					children: [/* @__PURE__ */ I("span", {
						className: "[&>svg]:size-5",
						children: e.icon
					}), e.label]
				}, e.to))
			})]
		})
	})] });
}
//#endregion
//#region src/components/navigation/CommandPalette/CommandPalette.tsx
function q(e, t) {
	if (!t.trim()) return e;
	let n = t.toLowerCase();
	return e.filter((e) => e.label.toLowerCase().includes(n) || e.group.toLowerCase().includes(n) || e.keywords?.some((e) => e.includes(n)));
}
function J(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) {
		let e = t.get(n.group);
		e ? e.push(n) : t.set(n.group, [n]);
	}
	return Array.from(t.entries());
}
function Y({ open: e, onClose: s, items: c, onSelect: l }) {
	let [u, p] = P(""), [m, h] = P(0), g = N(null), _ = q(c, u), v = J(_);
	j(() => {
		e && (p(""), h(0));
	}, [e]), j(() => {
		e && requestAnimationFrame(() => g.current?.focus());
	}, [e]);
	function y(e) {
		l(e), s();
	}
	function b(e) {
		if (e.key === "ArrowDown") e.preventDefault(), h((e) => Math.min(e + 1, _.length - 1));
		else if (e.key === "ArrowUp") e.preventDefault(), h((e) => Math.max(e - 1, 0));
		else if (e.key === "Enter") {
			let e = _[m];
			e && y(e.path);
		}
	}
	return /* @__PURE__ */ I(o, {
		open: e,
		onOpenChange: (e) => !e && s(),
		children: /* @__PURE__ */ L(r, { children: [/* @__PURE__ */ I(f, {}), /* @__PURE__ */ L(i, {
			className: "bg-background data-[state=closed]:animate-out data-[state=open]:animate-in data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[10vh] left-1/2 z-50 w-full max-w-140 -translate-x-1/2 overflow-hidden rounded-xl border shadow-2xl duration-200",
			onKeyDown: b,
			"aria-label": "Command palette",
			children: [
				/* @__PURE__ */ I(a, {
					className: "sr-only",
					children: "Search"
				}),
				/* @__PURE__ */ I(n, {
					className: "sr-only",
					children: "Search pages and actions"
				}),
				/* @__PURE__ */ L("div", {
					className: "flex items-center gap-3 border-b px-4 py-3",
					children: [
						/* @__PURE__ */ I(d, { className: "text-muted-foreground size-4 shrink-0" }),
						/* @__PURE__ */ I("input", {
							ref: g,
							value: u,
							onChange: (e) => {
								p(e.target.value), h(0);
							},
							placeholder: "Search pages and actions…",
							className: "placeholder:text-muted-foreground flex-1 bg-transparent text-base outline-none md:text-sm"
						}),
						/* @__PURE__ */ I("kbd", {
							className: "text-muted-foreground font-mono text-[11px]",
							children: "Esc"
						})
					]
				}),
				/* @__PURE__ */ I("div", {
					className: "max-h-[60vh] overflow-y-auto py-2",
					children: _.length === 0 ? /* @__PURE__ */ L(w, {
						variant: "body",
						color: "muted",
						className: "px-4 py-8 text-center",
						children: [
							"No results for “",
							u,
							"”"
						]
					}) : v.map(([e, n]) => /* @__PURE__ */ L("div", { children: [/* @__PURE__ */ I(w, {
						variant: "overline",
						className: "text-muted-foreground px-4 pt-3 pb-1",
						children: e
					}), n.map((e) => {
						let n = _.indexOf(e);
						return /* @__PURE__ */ L("button", {
							type: "button",
							className: t("flex w-full items-center gap-3 px-4 py-2.5 text-left text-sm transition-colors", n === m ? "bg-accent text-accent-foreground" : "text-foreground hover:bg-accent/50"),
							onMouseEnter: () => h(n),
							onClick: () => y(e.path),
							children: [e.icon && /* @__PURE__ */ I("span", {
								className: "text-muted-foreground",
								children: e.icon
							}), e.label]
						}, e.path);
					})] }, e))
				})
			]
		})] })
	});
}
//#endregion
//#region src/components/navigation/PageHeader/PageHeader.tsx
function X({ eyebrow: e = "Workspace", eyebrowClassName: t, title: n, subtitle: r, actions: i }) {
	return /* @__PURE__ */ L("div", {
		className: "mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between",
		children: [/* @__PURE__ */ L("div", { children: [
			/* @__PURE__ */ I(w, {
				variant: "overline",
				color: "muted",
				className: t,
				children: e
			}),
			/* @__PURE__ */ I(w, {
				variant: "display-lg",
				as: "h1",
				className: "mt-1.5 leading-none font-black tracking-tight",
				children: n
			}),
			r && /* @__PURE__ */ I(w, {
				variant: "body",
				color: "muted",
				className: "mt-2",
				children: r
			})
		] }), i && /* @__PURE__ */ I("div", {
			className: "flex shrink-0 items-center gap-2",
			children: i
		})]
	});
}
//#endregion
//#region src/components/navigation/AppShell/AppShell.constants.ts
var Z = "main-content";
//#endregion
//#region src/components/navigation/AppShell/useScrollReveal.ts
function ne(e, { hideThreshold: t = 160, scrollDelta: n = 8 } = {}) {
	let [r, i] = P(!1);
	return j(() => {
		let r = e.current;
		if (!r) return;
		let a = Math.max(0, r.scrollTop), o = () => {
			let e = Math.max(0, r.scrollTop);
			if (e <= 0) {
				i(!1), a = e;
				return;
			}
			let o = e - a;
			Math.abs(o) < n || (i(o > 0 && e > t), a = e);
		};
		return r.addEventListener("scroll", o, { passive: !0 }), () => r.removeEventListener("scroll", o);
	}, [
		e,
		t,
		n
	]), r;
}
//#endregion
//#region src/components/navigation/AppShell/AppShell.tsx
function re({ sidebar: e, topBar: n, bottomNav: r, children: i }) {
	let [a, o] = P(!1), s = N(null), c = ne(s);
	return /* @__PURE__ */ L("div", {
		className: "flex h-svh overflow-hidden",
		children: [
			e({
				mobileOpen: a,
				onMobileClose: () => o(!1)
			}),
			/* @__PURE__ */ L("div", {
				className: "relative flex flex-1 flex-col overflow-hidden",
				children: [n({
					onOpenMenu: () => o(!0),
					isHidden: c && !a
				}), /* @__PURE__ */ I("main", {
					ref: s,
					id: Z,
					className: t("flex-1 overflow-auto max-md:pt-[calc(60px+env(safe-area-inset-top))]", r && "pb-[calc(5rem+env(safe-area-inset-bottom))] md:pb-0"),
					children: i
				})]
			}),
			r
		]
	});
}
//#endregion
//#region src/components/navigation/AppShell/scroll-app-shell-to-top.ts
function ie() {
	let e = document.getElementById(Z);
	e && (e.scrollTop = 0);
}
//#endregion
//#region src/lib/useIsCompact.ts
function ae() {
	let [e, t] = P(() => window.matchMedia("(max-width: 1279px)").matches);
	return j(() => {
		let e = window.matchMedia("(max-width: 1279px)");
		t(e.matches);
		let n = (e) => t(e.matches);
		return e.addEventListener("change", n), () => e.removeEventListener("change", n);
	}, []), e;
}
//#endregion
//#region src/components/navigation/AppSidebar/AppSidebar.tsx
function oe(e) {
	try {
		return localStorage.getItem(e) === "true";
	} catch {
		return !1;
	}
}
function se(e, t) {
	try {
		localStorage.setItem(e, String(t));
	} catch {}
}
function Q(e, t) {
	return typeof e == "function" ? e({ collapsed: t }) : e;
}
function ce(e, t, n) {
	return t ? n === e : n === e || n.startsWith(`${e}/`);
}
function le({ branding: n, workspaceSwitcher: r, primaryNav: i, secondaryNav: a, userMenu: o, footer: c, accent: l = "workspace", linkComponent: u = "a", currentPath: d, storageKey: f, mobileOpen: p, onMobileClose: m }) {
	let h = T(), g = ae(), [_, v] = P(() => oe(f)), [x, C] = P(g), k = _ || x, M = A(() => {
		let e = !k;
		C(!1), v(e), se(f, e);
	}, [k, f]), R = N(g);
	j(() => {
		g !== R.current && C(g), R.current = g;
	}, [g]), j(() => {
		function e(e) {
			e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.key === "[" && !e.metaKey && !e.ctrlKey && M();
		}
		return document.addEventListener("keydown", e), () => document.removeEventListener("keydown", e);
	}, [M]);
	let z = !h && k, V = (e, n) => {
		let r = ce(e, n, d);
		return t("flex items-center rounded-lg transition-colors", z ? "justify-center px-0 py-2" : "gap-2.5 px-3 py-2", r ? l === "console" ? "bg-console-accent text-console-accent-foreground font-medium" : "bg-primary text-primary-foreground font-medium" : "text-muted-foreground hover:bg-muted hover:text-foreground", z ? "text-sm w-10 h-10" : "text-sm w-full");
	};
	function H(n, r) {
		return /* @__PURE__ */ L("div", { children: [n.label && /* @__PURE__ */ I(w, {
			variant: "overline",
			className: t(r > 0 && "mt-5", "px-3 pb-1.5 text-muted-foreground", z && "sr-only"),
			children: n.label
		}), /* @__PURE__ */ I("ul", {
			className: t("space-y-0.5", z && "flex flex-col items-center gap-0.5"),
			children: n.items.map((t) => /* @__PURE__ */ I("li", { children: /* @__PURE__ */ L(ee, { children: [/* @__PURE__ */ I(E, {
				asChild: !0,
				children: /* @__PURE__ */ I("span", {
					className: "block",
					children: /* @__PURE__ */ L(u, {
						...e(u, t.to),
						"aria-label": z ? t.label : void 0,
						className: V(t.to, t.end),
						children: [
							/* @__PURE__ */ I("span", {
								className: "shrink-0 [&>svg]:size-4",
								children: t.icon
							}),
							!z && t.label,
							!z && t.badge
						]
					})
				})
			}), z && /* @__PURE__ */ I(D, {
				side: "right",
				children: t.label
			})] }, z ? "collapsed" : "expanded") }, t.to))
		})] }, n.label ?? r);
	}
	let U = /* @__PURE__ */ L(F, { children: [
		/* @__PURE__ */ L("div", {
			className: t("flex items-center px-4 pt-4 pb-3", z ? "flex-col gap-2 px-2" : "gap-2"),
			children: [/* @__PURE__ */ I("div", {
				className: t("flex items-center gap-2.5", !z && "flex-1 min-w-0"),
				children: Q(n, z)
			}), !h && /* @__PURE__ */ I(s, {
				variant: "ghost",
				size: "icon",
				onClick: M,
				"aria-label": z ? "Expand sidebar" : "Collapse sidebar",
				"aria-expanded": !z,
				"aria-controls": "app-sidebar",
				className: "shrink-0 md:flex",
				children: I(z ? te : B, { className: "size-4" })
			})]
		}),
		r && /* @__PURE__ */ I("div", {
			className: t("pb-3", z ? "px-1.5" : "px-3"),
			children: Q(r, z)
		}),
		/* @__PURE__ */ L("nav", {
			"aria-label": "Primary",
			className: t("flex-1 overflow-y-auto", z ? "px-1.5" : "px-3"),
			onClick: h ? m : void 0,
			children: [i.map(H), a?.map((e, t) => H(e, i.length + t))]
		}),
		/* @__PURE__ */ L("div", {
			className: t("pt-0 space-y-4", z ? "p-1.5 flex-col flex items-center" : "p-3"),
			children: [Q(o, z), c && Q(c, z)]
		})
	] });
	return h ? /* @__PURE__ */ I(y, {
		open: p,
		onOpenChange: (e) => {
			e || m();
		},
		children: /* @__PURE__ */ L(b, {
			side: "left",
			className: "flex w-[90%] max-w-sm flex-col p-0 pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] pl-[env(safe-area-inset-left)] [&>button]:top-[calc(1rem+env(safe-area-inset-top))]",
			children: [/* @__PURE__ */ I(S, {
				className: "sr-only",
				children: "Sidebar navigation"
			}), /* @__PURE__ */ I(O, {
				delayDuration: 300,
				children: U
			})]
		})
	}) : /* @__PURE__ */ I(O, {
		delayDuration: 300,
		children: /* @__PURE__ */ I("aside", {
			id: "app-sidebar",
			"aria-label": "Sidebar navigation",
			className: t("relative flex h-svh shrink-0 flex-col border-r bg-background transition-[width] duration-200", z ? "w-[60px]" : "w-60"),
			children: U
		})
	});
}
//#endregion
//#region src/components/navigation/TopBar/TopBar.tsx
function ue({ onOpenMenu: n, breadcrumbs: r, envBadge: i, search: a, actions: o, isHidden: s = !1, linkComponent: c = "a" }) {
	return /* @__PURE__ */ L("header", {
		className: t("bg-background/85 sticky top-0 z-10 flex h-[calc(60px+env(safe-area-inset-top))] shrink-0 items-center gap-3 border-b pt-[env(safe-area-inset-top)] pr-[max(1rem,env(safe-area-inset-right))] pl-[max(1rem,env(safe-area-inset-left))] backdrop-blur-sm max-md:absolute max-md:inset-x-0 max-md:transition-transform max-md:duration-500 max-md:ease-[cubic-bezier(0.22,1,0.36,1)] max-md:focus-within:translate-y-0 motion-reduce:transition-none md:pr-[max(1.5rem,env(safe-area-inset-right))] md:pl-[max(1.5rem,env(safe-area-inset-left))]", s && "max-md:-translate-y-full"),
		children: [
			/* @__PURE__ */ I("button", {
				type: "button",
				"aria-label": "Open menu",
				onClick: n,
				className: "hover:bg-muted shrink-0 rounded-md p-1.5 md:hidden",
				children: /* @__PURE__ */ I(z, { className: "size-5" })
			}),
			i,
			/* @__PURE__ */ I("nav", {
				"aria-label": "Breadcrumb",
				className: "hidden min-w-0 items-center gap-1.5 md:flex",
				children: r.map((n, i) => /* @__PURE__ */ L(k, { children: [i > 0 && /* @__PURE__ */ I(u, { className: "text-muted-foreground/50 size-3.5 shrink-0" }), n.content ? n.content : n.href ? /* @__PURE__ */ I(c, {
					...e(c, n.href),
					className: "text-muted-foreground hover:text-foreground text-sm transition-colors",
					children: n.label
				}) : /* @__PURE__ */ I("span", {
					className: t("text-sm", i === r.length - 1 ? "font-semibold text-foreground" : "text-muted-foreground"),
					children: n.label
				})] }, `${n.label}-${i}`))
			}),
			/* @__PURE__ */ I("div", { className: "hidden flex-1 md:block" }),
			a,
			o
		]
	});
}
//#endregion
//#region src/components/navigation/SplitPanelLayout/SplitPanelLayout.tsx
var de = "split-panel-aside-collapsed";
function fe(e) {
	try {
		return localStorage.getItem(e) === "true";
	} catch {
		return !1;
	}
}
function pe(e, t) {
	try {
		localStorage.setItem(e, String(t));
	} catch {}
}
function me({ children: e, aside: n, storageKey: r = de, asideLabel: i = "details", isAsideSticky: a = !1, className: o }) {
	let c = M(), [l, u] = P(() => fe(r));
	function d() {
		let e = !l;
		u(e), pe(r, e);
	}
	return /* @__PURE__ */ L("div", {
		className: o,
		children: [/* @__PURE__ */ I("div", {
			className: "mb-2 hidden justify-end lg:flex",
			children: /* @__PURE__ */ L(s, {
				type: "button",
				variant: "ghost",
				size: "sm",
				className: "text-muted-foreground hover:text-foreground h-7 gap-1.5 text-xs",
				onClick: d,
				"aria-expanded": !l,
				"aria-controls": c,
				children: [/* @__PURE__ */ I(l ? H : V, { className: "size-3.5" }), l ? `Show ${i}` : `Hide ${i}`]
			})
		}), /* @__PURE__ */ L("div", {
			"data-testid": "split-panel-grid",
			className: t("flex flex-col gap-4 lg:grid lg:items-start lg:gap-6", l ? "lg:grid-cols-[minmax(0,1fr)]" : "lg:grid-cols-[minmax(0,1fr)_clamp(280px,30%,420px)]"),
			children: [/* @__PURE__ */ I("div", {
				"data-testid": "split-panel-main",
				className: "@container min-w-0",
				children: e
			}), /* @__PURE__ */ I("div", {
				id: c,
				"data-testid": "split-panel-aside",
				className: t("min-w-0", a && "lg:sticky lg:top-5", l && "lg:hidden"),
				children: n
			})]
		})]
	});
}
//#endregion
//#region src/components/navigation/SectionNav/SectionNav.tsx
function $(e, t) {
	return e.end ? t === e.to : t === e.to || t.startsWith(`${e.to}/`);
}
function he({ sections: n, currentPath: r, linkComponent: i = "a", ariaLabel: a = "Sections", className: o }) {
	let c = n.find((e) => e.items.some((e) => $(e, r))), l = c?.items.find((e) => $(e, r)), [u, d] = P(!1), f = N(null);
	function y(e) {
		f.current = e.pointerType, e.pointerType !== "mouse" && e.preventDefault();
	}
	function b() {
		f.current !== null && f.current !== "mouse" && d((e) => !e), f.current = null;
	}
	function x() {
		f.current = null;
	}
	return /* @__PURE__ */ L("div", {
		className: o,
		children: [/* @__PURE__ */ I("nav", {
			"aria-label": a,
			className: "hidden space-y-5 lg:block",
			children: n.map((n, a) => /* @__PURE__ */ L("div", { children: [n.label && /* @__PURE__ */ I(w, {
				variant: "overline",
				color: "muted",
				className: "px-3 pb-1.5",
				children: n.label
			}), /* @__PURE__ */ I("ul", {
				className: "space-y-0.5",
				children: n.items.map((n) => {
					let a = $(n, r);
					return /* @__PURE__ */ I("li", { children: /* @__PURE__ */ L(i, {
						...e(i, n.to),
						"aria-current": a ? "page" : void 0,
						className: t("flex w-full items-center gap-2.5 rounded-lg px-3 py-2 text-sm font-medium transition-colors", a ? "bg-muted text-foreground" : "text-muted-foreground hover:bg-muted hover:text-foreground"),
						children: [
							/* @__PURE__ */ I("span", {
								className: "shrink-0 [&>svg]:size-4",
								children: n.icon
							}),
							n.label,
							n.badge && /* @__PURE__ */ I("span", {
								className: "ml-auto",
								children: n.badge
							})
						]
					}) }, n.to);
				})
			})] }, n.label ?? a))
		}), /* @__PURE__ */ I("div", {
			className: "lg:hidden",
			children: /* @__PURE__ */ L(v, {
				open: u,
				onOpenChange: d,
				children: [/* @__PURE__ */ I(m, {
					asChild: !0,
					children: /* @__PURE__ */ L(s, {
						type: "button",
						variant: "outline",
						onPointerDown: y,
						onPointerCancel: x,
						onKeyDown: x,
						onClick: b,
						"aria-label": `${a}: ${l?.label ?? "Choose a page"}`,
						className: "h-12 w-full justify-start gap-2.5 rounded-xl",
						children: [
							l && /* @__PURE__ */ I("span", {
								className: "shrink-0 [&>svg]:size-4",
								children: l.icon
							}),
							/* @__PURE__ */ L("span", {
								className: "flex min-w-0 flex-1 flex-col items-start leading-tight",
								children: [c?.label && /* @__PURE__ */ I("span", {
									className: "text-muted-foreground text-[11px] font-normal",
									children: c.label
								}), /* @__PURE__ */ I("span", { children: l?.label ?? "Choose a page" })]
							}),
							/* @__PURE__ */ I(R, {
								className: "text-muted-foreground size-4",
								"aria-hidden": !0
							})
						]
					})
				}), /* @__PURE__ */ I(_, {
					align: "start",
					className: "max-h-[60vh] w-(--radix-dropdown-menu-trigger-width)",
					children: n.map((t, n) => /* @__PURE__ */ L(h, { children: [t.label && /* @__PURE__ */ I(g, { children: t.label }), t.items.map((t) => /* @__PURE__ */ I(p, {
						asChild: !0,
						children: /* @__PURE__ */ L(i, {
							...e(i, t.to),
							"aria-current": $(t, r) ? "page" : void 0,
							className: "gap-2.5",
							children: [
								/* @__PURE__ */ I("span", {
									className: "shrink-0 [&>svg]:size-4",
									children: t.icon
								}),
								t.label,
								t.badge && /* @__PURE__ */ I("span", {
									className: "ml-auto",
									children: t.badge
								})
							]
						})
					}, t.to))] }, t.label ?? n))
				})]
			})
		})]
	});
}
//#endregion
export { ie as a, X as c, W as d, U as f, le as i, Y as l, me as n, re as o, R as p, ue as r, Z as s, he as t, K as u };

//# sourceMappingURL=navigation-C9BYVgBO.js.map